import { render, staticRenderFns } from "./environment-banner.vue?vue&type=template&id=2d29dd0e"
import script from "./environment-banner.vue?vue&type=script&lang=js"
export * from "./environment-banner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports